import {get, post} from "@/api/request";

/**
 * 数据检索首页查询
 * @param region{number} 区域
 * @param province{string} 省份
 * @param unit{number} 单位
 * @param timeZone{Array} 时间范围
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_data = async function (region, province, unit, timeZone) {
    let start_time = undefined
    let end_time = undefined
    if (timeZone.length > 0) {
        start_time = timeZone[0]
        end_time = timeZone[1]
    }
    return await get('/admin/data/search', {
        params: {
            region, province, unit, start_time, end_time
        }
    })
}

/**
 * 数据检索中的平台和异常指标模块数据检索
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_anomaly_index_data = async function (params) {
    return await get('/admin/data/search/report', {
        params
    })
}

/**
 * 数据检索中的疾病因素
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_effect_factor_data = async function (params) {
    return await get('/admin/data/indicat', {
        params
    })
}

/**
 * 数据检索中的疾病因素
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_disease_data = async function (params) {
    return await get('/admin/data/factor', {
        params
    })
}

/**
 * 数据检索中的疾病详情
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_disease_info_data = async function (params) {
    return await get('/admin/data/disease', {
        params
    })
}

/**
 * 数据检索中的报告类型模块数据检索
 * @param conversation_ids{Array} 查询范围
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
// export const get_report_type_data = async function (conversation_ids) {
//     return await post('/admin/data/search/report/type', {
//         data: {
//             conversation_ids
//         }
//     })
// }

export const get_report_type_data = async function (params) {
    return await get('/admin/data/platre', {
        params,
    })
}

export const get_report_type_data_anomaly = async function (params) {
    return await get('/admin/data/repindicat', {
        params,
    })
}

export const get_report_type_data_factor = async function (params) {
    return await get('/admin/data/indicator', {
        params,
    })
}

export const get_report_type_data_disease = async function (params) {
    return await get('/admin/data/facdisecat', {
        params,
    })
}

export const get_report_type_data_disease_info = async function (params) {
    return await get('/admin/data/diseacatitem', {
        params,
    })
}

/**
 * 数据检索中的疾病因素模块数据检索
 * @param conversation_ids{Array} 查询范围
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
// export const get_disease_factors_data = async function (conversation_ids) {
//     return await post('/admin/data/search/disease/factors', {
//         data: {
//             conversation_ids
//         }
//     })
// }


export const get_disease_factors_data = async function (params) {
    return await get('/admin/data/disa', {
        params,
    })
}

export const get_disease_factors_data_info = async function (params) {
    return await get('/admin/data/sud', {
        params,
    })
}


/**
 * 数据检索中的疾病次数模块数据检索
 * @param conversation_ids{Array} 查询范围
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
// export const get_disease_number_data = async function (conversation_ids) {
//     return await post('/admin/data/search/disease/number', {
//         data: {
//             conversation_ids
//         }
//     })
// }
export const get_disease_number_data = async function (params) {
    return await get('/admin/data/jibing', {
        params,
    })
}